import React from 'react';
import { WarningCircle } from '@phosphor-icons/react';

// Highlight fields with low AI confidence so the user reviews them before saving
export const confidenceRing = (level) => {
  if (level === 'low') return 'ring-2 ring-amber-400 border-amber-400';
  if (level === 'medium') return 'ring-1 ring-amber-200';
  return '';
};

export const ConfidenceBadge = ({ level }) => {
  if (level === 'low') {
    return (
      <span className="inline-flex items-center gap-1 text-xs text-amber-700 bg-amber-50 px-2 py-0.5 rounded">
        <WarningCircle size={12} weight="fill" /> Review
      </span>
    );
  }
  return null;
};
